import script from "./MyOrderClosedList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyOrderClosedList.vue?vue&type=script&setup=true&lang=ts"

import "./MyOrderClosedList.vue?vue&type=style&index=0&id=e908c876&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e908c876"]])

export default __exports__